/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreateOverwolfGameBodySteamData } from './CreateOverwolfGameBodySteamData';
import {
    CreateOverwolfGameBodySteamDataFromJSON,
    CreateOverwolfGameBodySteamDataFromJSONTyped,
    CreateOverwolfGameBodySteamDataToJSON,
    CreateOverwolfGameBodySteamDataToJSONTyped,
} from './CreateOverwolfGameBodySteamData';
import type { CreateOverwolfGameBodySeo } from './CreateOverwolfGameBodySeo';
import {
    CreateOverwolfGameBodySeoFromJSON,
    CreateOverwolfGameBodySeoFromJSONTyped,
    CreateOverwolfGameBodySeoToJSON,
    CreateOverwolfGameBodySeoToJSONTyped,
} from './CreateOverwolfGameBodySeo';

/**
 * 
 * @export
 * @interface CreateOverwolfGameBody
 */
export interface CreateOverwolfGameBody {
    /**
     * 
     * @type {string}
     * @memberof CreateOverwolfGameBody
     */
    gameId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOverwolfGameBody
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOverwolfGameBody
     */
    description?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateOverwolfGameBody
     */
    events: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof CreateOverwolfGameBody
     */
    isEventSupported: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateOverwolfGameBody
     */
    isEventSupportReady: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateOverwolfGameBody
     */
    timeTrackedGame?: boolean;
    /**
     * Whether this entry is a platform launcher (Battle.net, Epic, Steam, etc.). Used to suppress launcher heartbeats when a non-launcher game is the current session.
     * @type {boolean}
     * @memberof CreateOverwolfGameBody
     */
    isLauncher?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateOverwolfGameBody
     */
    slug?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOverwolfGameBody
     */
    trackingProvider?: CreateOverwolfGameBodyTrackingProviderEnum;
    /**
     * 
     * @type {number}
     * @memberof CreateOverwolfGameBody
     */
    steamAppId?: number;
    /**
     * Genre categories for carousel grouping (FPS, MOBA, RPG, etc.)
     * @type {Array<string>}
     * @memberof CreateOverwolfGameBody
     */
    devourCategories?: Array<string>;
    /**
     * Whether competitions (tournaments, challenges, ladders) are supported for this game
     * @type {boolean}
     * @memberof CreateOverwolfGameBody
     */
    competitionSupported?: boolean;
    /**
     * External game identifier used by Blitz integration
     * @type {string}
     * @memberof CreateOverwolfGameBody
     */
    blitzGameId?: string;
    /**
     * Hex color for competition card branding (e.g.,
     * @type {string}
     * @memberof CreateOverwolfGameBody
     */
    brandColor?: string;
    /**
     * 
     * @type {CreateOverwolfGameBodySeo}
     * @memberof CreateOverwolfGameBody
     */
    seo?: CreateOverwolfGameBodySeo;
    /**
     * 
     * @type {CreateOverwolfGameBodySteamData}
     * @memberof CreateOverwolfGameBody
     */
    steamData?: CreateOverwolfGameBodySteamData;
    /**
     * Whether the game supports automatic score capture
     * @type {boolean}
     * @memberof CreateOverwolfGameBody
     */
    autoScoringCapable?: boolean;
    /**
     * Challenge Arena configuration for this game
     * @type {object}
     * @memberof CreateOverwolfGameBody
     */
    arenaConfig?: object;
    /**
     * Steam match data for this game
     * @type {object}
     * @memberof CreateOverwolfGameBody
     */
    steamMatch?: object;
    /**
     * Master toggle for Overwolf clip capture for this game
     * @type {boolean}
     * @memberof CreateOverwolfGameBody
     */
    clipEnabled?: boolean;
    /**
     * Windows exe name used by the Overwolf recorder (e.g. VALORANT-Win64-Shipping.exe)
     * @type {string}
     * @memberof CreateOverwolfGameBody
     */
    gameProcess?: string;
    /**
     * Twitch game_id values that map to this title. Lets a roster be filtered to the game.
     * @type {Array<string>}
     * @memberof CreateOverwolfGameBody
     */
    twitchGameIds?: Array<string>;
    /**
     * Kick category.id values that map to this title.
     * @type {Array<string>}
     * @memberof CreateOverwolfGameBody
     */
    kickCategoryIds?: Array<string>;
    /**
     * Lowercased YouTube game names — YouTube exposes no stable per-title game id.
     * @type {Array<string>}
     * @memberof CreateOverwolfGameBody
     */
    youtubeGameNames?: Array<string>;
    /**
     * Lowercased title/tag aliases, matched only when no category resolves.
     * @type {Array<string>}
     * @memberof CreateOverwolfGameBody
     */
    streamTitleAliases?: Array<string>;
}


/**
 * @export
 */
export const CreateOverwolfGameBodyTrackingProviderEnum = {
    overwolf: 'overwolf',
    blitz: 'blitz',
    steam: 'steam',
    TimeOnly: 'time-only'
} as const;
export type CreateOverwolfGameBodyTrackingProviderEnum = typeof CreateOverwolfGameBodyTrackingProviderEnum[keyof typeof CreateOverwolfGameBodyTrackingProviderEnum];


/**
 * Check if a given object implements the CreateOverwolfGameBody interface.
 */
export function instanceOfCreateOverwolfGameBody(value: object): value is CreateOverwolfGameBody {
    if (!('gameId' in value) || value['gameId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('events' in value) || value['events'] === undefined) return false;
    if (!('isEventSupported' in value) || value['isEventSupported'] === undefined) return false;
    if (!('isEventSupportReady' in value) || value['isEventSupportReady'] === undefined) return false;
    return true;
}

export function CreateOverwolfGameBodyFromJSON(json: any): CreateOverwolfGameBody {
    return CreateOverwolfGameBodyFromJSONTyped(json, false);
}

export function CreateOverwolfGameBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOverwolfGameBody {
    if (json == null) {
        return json;
    }
    return {
        
        'gameId': json['gameId'],
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'events': json['events'],
        'isEventSupported': json['isEventSupported'],
        'isEventSupportReady': json['isEventSupportReady'],
        'timeTrackedGame': json['timeTrackedGame'] == null ? undefined : json['timeTrackedGame'],
        'isLauncher': json['isLauncher'] == null ? undefined : json['isLauncher'],
        'slug': json['slug'] == null ? undefined : json['slug'],
        'trackingProvider': json['trackingProvider'] == null ? undefined : json['trackingProvider'],
        'steamAppId': json['steamAppId'] == null ? undefined : json['steamAppId'],
        'devourCategories': json['devourCategories'] == null ? undefined : json['devourCategories'],
        'competitionSupported': json['competitionSupported'] == null ? undefined : json['competitionSupported'],
        'blitzGameId': json['blitzGameId'] == null ? undefined : json['blitzGameId'],
        'brandColor': json['brandColor'] == null ? undefined : json['brandColor'],
        'seo': json['seo'] == null ? undefined : CreateOverwolfGameBodySeoFromJSON(json['seo']),
        'steamData': json['steamData'] == null ? undefined : CreateOverwolfGameBodySteamDataFromJSON(json['steamData']),
        'autoScoringCapable': json['autoScoringCapable'] == null ? undefined : json['autoScoringCapable'],
        'arenaConfig': json['arenaConfig'] == null ? undefined : json['arenaConfig'],
        'steamMatch': json['steamMatch'] == null ? undefined : json['steamMatch'],
        'clipEnabled': json['clipEnabled'] == null ? undefined : json['clipEnabled'],
        'gameProcess': json['gameProcess'] == null ? undefined : json['gameProcess'],
        'twitchGameIds': json['twitchGameIds'] == null ? undefined : json['twitchGameIds'],
        'kickCategoryIds': json['kickCategoryIds'] == null ? undefined : json['kickCategoryIds'],
        'youtubeGameNames': json['youtubeGameNames'] == null ? undefined : json['youtubeGameNames'],
        'streamTitleAliases': json['streamTitleAliases'] == null ? undefined : json['streamTitleAliases'],
    };
}

export function CreateOverwolfGameBodyToJSON(json: any): CreateOverwolfGameBody {
    return CreateOverwolfGameBodyToJSONTyped(json, false);
}

export function CreateOverwolfGameBodyToJSONTyped(value?: CreateOverwolfGameBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'gameId': value['gameId'],
        'name': value['name'],
        'description': value['description'],
        'events': value['events'],
        'isEventSupported': value['isEventSupported'],
        'isEventSupportReady': value['isEventSupportReady'],
        'timeTrackedGame': value['timeTrackedGame'],
        'isLauncher': value['isLauncher'],
        'slug': value['slug'],
        'trackingProvider': value['trackingProvider'],
        'steamAppId': value['steamAppId'],
        'devourCategories': value['devourCategories'],
        'competitionSupported': value['competitionSupported'],
        'blitzGameId': value['blitzGameId'],
        'brandColor': value['brandColor'],
        'seo': CreateOverwolfGameBodySeoToJSON(value['seo']),
        'steamData': CreateOverwolfGameBodySteamDataToJSON(value['steamData']),
        'autoScoringCapable': value['autoScoringCapable'],
        'arenaConfig': value['arenaConfig'],
        'steamMatch': value['steamMatch'],
        'clipEnabled': value['clipEnabled'],
        'gameProcess': value['gameProcess'],
        'twitchGameIds': value['twitchGameIds'],
        'kickCategoryIds': value['kickCategoryIds'],
        'youtubeGameNames': value['youtubeGameNames'],
        'streamTitleAliases': value['streamTitleAliases'],
    };
}

